let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("arhgZ"), load("2gL7f")]).then(() => parcelRequire('8nmH7'));